import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

interface Message {
  id: number;
  text: string;
  idTopic: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

@Component({
  selector: 'app-vs-message-box',
  templateUrl: './vs-message-box.component.html',
  styleUrls: ['./vs-message-box.component.scss']
})

export class VsMessageBoxComponent implements OnInit {

  messages: Message[] = [];
  private nextId = 1;
  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
  }

  show(text: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', idTopic: string = '') {

    // Giới hạn message tối đa 150 ký tự
    let truncatedText = text.length > 150 ? text.substring(0, 150) + '...' : text;

    const message: Message = {
      id: this.nextId++,
      text: truncatedText,
      type,
      idTopic,
    };

    this.messages.push(message);

    // Tự động xóa sau 3 giây
    setTimeout(() => {
      this.remove(message.id);
    }, 3000);
  }

  remove(id: number) {
    this.messages = this.messages.filter(msg => msg.id !== id);
  }

  clickMessage(id: number, idTopic: string) {
    this.remove(id);
    this.router.navigate(['/chat/', idTopic]);
  }

  getIcon(type: string): string {
    switch (type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'warning': return '⚠';
      case 'info': return 'ℹ';
      default: return 'ℹ';
    }
  }

  trackById(index: number, item: Message): number {
    return item.id;
  }

}
